import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {AuthenticationService} from '../services/';
import {ImportValidationService} from '@harmony-modules/payroll/services/admin-setup/import-validation.service';


declare var $: any;

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.token) {
      const headers: { [name: string]: string } = {
        Authorization: `Bearer ${currentUser.token}`
      };

      // Import Readiness Workbench support token (issued after AppId authorize).
      const url = (request.url || '').toLowerCase();
      if (url.includes('importvalidation')) {
        const companyId = currentUser.selectedCompany?.companyId;
        const userId = currentUser.id;
        const supportToken = ImportValidationService.getSupportToken(companyId, userId);
        if (supportToken) {
          headers[ImportValidationService.supportTokenHeader] = supportToken;
        }
      }

      request = request.clone({ setHeaders: headers });
    }

    return (next.handle(request).pipe(
      (tap(evt => {
      })) as any,
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // logout() itself POSTs RevokeSupportAuthorization; letting that call's own 401
          // come back through here would call logout() again, and so on without bound.
          const isLogoutTeardown = (request.url || '').toLowerCase().includes('revokesupportauthorization');
          if (err.status === 401 && !isLogoutTeardown) {
            $('.modal').modal('hide');
            this.authenticationService.logout();
            this.router.navigate(['login']);
          }
        }
        // return of(err);
        return throwError(err);
      }))) as any;
  }
}
